const Footer = () => {
  return (
    <>
      <section
        className="bg-green-100  w-full py-5 
            fixed bottom-0" >
        <h2>E-com dashboard</h2>
      </section>
    </>
  );
};

export default Footer;
